var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNsgAnarch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1056 1056"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_ANARCH_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 792h792V0H0Z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_ANARCH_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 1056)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-9.027-20.894 67.785 6.105a3078 3078 0 0 1 100.23-77.531l-173.83 46.231-.929-20.449 274.511-73.006-44.719 31.924C163.424-71.499 113.582-33.519 65.056 5.846L13.87 1.249Z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(531.635 415.541)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 10.418 18.858-29.709 3.695c.587 2.155 1.193 4.314 1.77 6.467 20.24 75.512 37.798 152.568 52.343 229.667l39.349-151.964 11.463 35.515-54.478 210.391-7.918-45.658C7.386 215.555-12.827 123.781-36.839 34.198a1825 1825 0 0 0-7.935-28.629l32.447-4.036z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(202.483 422.99)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-113.389-123.999C-84.873-49.486-56.86 27.746-33.566 104.597l16.238-2.02 10.418 18.859-20.865 2.594-20.096 2.5c-29.055-98.698-66.578-198.617-103.337-292.884l-19.471-49.933L12.203-16.293z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(201.083 286.512)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-27.773 107.258C38.6 37.599 108.765-29.421 181.217-92.346a3025 3025 0 0 1 23.678-20.346l-31.715-2.856 28.25-17.536 18.742 1.688 34.532 3.109a3020 3020 0 0 0-60.371 51.041C112.59-6.253 33.778 69.987-39.914 149.356l-26.931 29.005L-23.213 9.86Z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(324.43 564.025)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 140.756-36.648A1593 1593 0 0 1-2.765-60.776l-.94-20.67a1570 1570 0 0 0 201.319 30.587l57.965 4.981L.929 20.425z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(514.244 313.411)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-61.347-23.149-113.526-46.754-157.833-68.54L-35.16 61.952l-12.172 16.252-204.841-217.897 52.503 27.459C-148.203-85.317-83.212-53.29-1.368-21.917z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(269.15 180.621)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-8.979-20.782-48.014 25.1-5.129-11.316-59.092 26.385-12.317-23.758-75.202 33.527 21.902 41.398 22.95-7.265 37 14.886 1.8 16.304-115.868 49.736-71.809-129.99 108.179-144.441-6.158-98.656 89.91 34.649-.152-30.648 86.324 34.667-3.876 57.069 34.308 40.296z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(495.014 330.788)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-13.882 4.396-4.094-7.738L20.466-20.48 32.787 3.287l58.16-25.969 5.652 12.471 47.678-24.925 34.245 79.252L134 71.754l6.498 14.335-52.383 19.65 6.218 11.506-64.848 22.88 5.499 11.277-62.455 26.53-21.444-66.438L59.499 64.957 54.76 22.032Z",
  style: {
    fill: "#e26b35",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(331.939 372.843)"
})));
export default SvgNsgAnarch;